var _defs, _circle, _path, _circle2, _circle3, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartialDepreciation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 4.455,
    cy: 27.961,
    r: 1.399
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M7.115 23.857l2.652-4.22h12.89l4.692 4.613 9.198 2.367v6.156h-3.936M24.519 32.773h-7.987M9.706 32.773H4.455"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_sub",
    cx: 13.119,
    cy: 33.516,
    r: 3.413
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_sub",
    cx: 28.302,
    cy: 33.516,
    r: 3.413
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M31.217 5.591v11.798l-3.81-3.964M35.134 13.31l-3.917 4.079"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartialDepreciation);
export default __webpack_public_path__ + "static/media/partialDepreciation.6a1a2b23f1fcc762a989627f27f1cbeb.svg";
export { ForwardRef as ReactComponent };